import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageNavBreadcrumbs from "src/features/breadcrumbs/PageNavBreadcrumbs";
import BaseHeader from "src/pages/layout/Header";
import GeneralFilters from "src/features/resellerCustomers/GeneralFilters";
import "./Header.scss";
const Header = () => {
    return (_jsxs(BaseHeader, { className: 'reseller-clients-header', children: [_jsx(PageNavBreadcrumbs, {}), _jsx(GeneralFilters, {})] }));
};
export default Header;
